(() => {
  const focusableMedia = '.product__media-toggle, .deferred-media__poster';

  const syncGallery = (root) => {
    const slider = root.querySelector('.product__media-list.js-media-list');
    if (!slider) return;

    const slides = [...slider.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide')];
    const hasActiveSlide = slides.some((slide) => slide.classList.contains('swiper-slide-active'));

    slides.forEach((slide, index) => {
      const active = hasActiveSlide ? slide.classList.contains('swiper-slide-active') : index === 0;
      slide.querySelectorAll(focusableMedia).forEach((control) => {
        control.tabIndex = active ? 0 : -1;
      });
    });
  };

  const modalFocusReturns = new WeakMap();

  const syncModal = (modal) => {
    const open = modal.hasAttribute('open');
    modal.toggleAttribute('inert', !open);
    modal.setAttribute('aria-hidden', String(!open));

    if (open) {
      const active = document.activeElement;
      if (active && !modal.contains(active)) modalFocusReturns.set(modal, active);

      window.requestAnimationFrame(() => {
        modal.querySelector('.product-media-modal__toggle, [data-modal-close]')?.focus();
      });
      return;
    }

    const returnTarget = modalFocusReturns.get(modal);
    if (returnTarget?.isConnected) {
      window.requestAnimationFrame(() => returnTarget.focus({ preventScroll: true }));
    }
    modalFocusReturns.delete(modal);
  };

  const repairDuplicateSvgIds = () => {
    const seen = new Set();
    let duplicateIndex = 0;

    document.querySelectorAll('svg [id]').forEach((node) => {
      const originalId = node.getAttribute('id');
      if (!originalId) return;

      if (!seen.has(originalId) && document.getElementById(originalId) === node) {
        seen.add(originalId);
        return;
      }

      const svg = node.closest('svg');
      if (!svg) return;

      let uniqueId;
      do {
        duplicateIndex += 1;
        uniqueId = `${originalId}--vzy-${duplicateIndex}`;
      } while (seen.has(uniqueId) || document.getElementById(uniqueId));
      seen.add(uniqueId);
      node.setAttribute('id', uniqueId);

      const escapedId = originalId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const reference = new RegExp(`#${escapedId}(?=[\\s)"']|$)`, 'g');

      svg.querySelectorAll('*').forEach((candidate) => {
        [...candidate.attributes].forEach((attribute) => {
          if (!attribute.value.includes(`#${originalId}`)) return;
          candidate.setAttribute(
            attribute.name,
            attribute.value.replace(reference, `#${uniqueId}`)
          );
        });
      });
    });
  };

  const repairDuplicateStylesheets = () => {
    const seen = new Set();

    document.querySelectorAll('link[rel="stylesheet"][href]').forEach((link) => {
      const href = link.href;
      if (!href) return;

      if (seen.has(href)) {
        link.remove();
        return;
      }

      seen.add(href);
    });
  };

  const repairDynamicMarkup = () => {
    repairDuplicateSvgIds();
    repairDuplicateStylesheets();
  };

  const watchThirdPartySvgIds = () => {
    let timer;
    const scheduleRepair = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(repairDynamicMarkup, 80);
    };

    repairDynamicMarkup();

    const observer = new MutationObserver(scheduleRepair);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[id^="MainProduct-"]').forEach((root) => {
      if (root.dataset.vzyA11yReady === 'true') return;
      root.dataset.vzyA11yReady = 'true';

      syncGallery(root);
      const slider = root.querySelector('.product__media-list.js-media-list');
      if (slider) {
        new MutationObserver(() => syncGallery(root)).observe(slider, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }

      const modalId = root.id.replace('MainProduct-', 'ProductModal-');
      const modal = document.getElementById(modalId);
      if (modal) {
        syncModal(modal);
        new MutationObserver(() => {
          syncModal(modal);
          document.dispatchEvent(new CustomEvent('vzy:surface-state'));
        }).observe(modal, {
          attributes: true,
          attributeFilter: ['open']
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { init(); watchThirdPartySvgIds(); }, { once: true });
  } else {
    init();
    watchThirdPartySvgIds();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
